import React, { forwardRef } from 'react';
import { SHADCN, R, TYPO, S, FS } from '../theme';

// ── <Input> — Shadcn dark ───────────────────────────────────────────────────
// Fond white@10%, filet white@20%, radius 10, focus ring peach.

const Input = forwardRef(function Input(
  { error = false, type = 'text', style, onFocus, onBlur, fontSize = FS.body, as = 'input', ...rest },
  ref
) {
  const Tag = as;
  const tagProps = as === 'textarea' ? {} : { type };

  const baseBorder = error ? SHADCN.destructive : SHADCN.input;

  return (
    <Tag
      ref={ref}
      {...tagProps}
      {...rest}
      style={{
        ...TYPO.body,
        fontSize,
        background: SHADCN.sidebarAccent,
        border: `1px solid ${baseBorder}`,
        borderRadius: R.md,
        padding: `10px ${S[4]}px`,
        color: SHADCN.fg,
        outline: 'none',
        letterSpacing: type === 'password' ? '0.08em' : '0',
        transition: `border-color ${SHADCN.durBase} ${SHADCN.easeOut}, box-shadow ${SHADCN.durBase} ${SHADCN.easeOut}, background ${SHADCN.durBase} ${SHADCN.easeOut}`,
        width: '100%',
        boxSizing: 'border-box',
        fontFamily: SHADCN.font,
        ...style,
      }}
      onFocus={(e) => {
        if (!error) {
          e.target.style.borderColor = SHADCN.primary;
          e.target.style.boxShadow = `0 0 0 3px oklch(0.837 0.128 66.29 / 0.2)`;
        } else {
          e.target.style.boxShadow = `0 0 0 3px oklch(0.577 0.245 27.325 / 0.2)`;
        }
        if (onFocus) onFocus(e);
      }}
      onBlur={(e) => {
        e.target.style.borderColor = error ? SHADCN.destructive : SHADCN.input;
        e.target.style.boxShadow = 'none';
        if (onBlur) onBlur(e);
      }}
    />
  );
});

export default Input;
